import * as firebase from 'firebase';
import firestore from 'firebase/firestore'

const settings = {};
// Initialize Firebase
var config = {
    apiKey: "AIzaSyCTFmSeD5zlARL7PBS_PGS-02vA9WIQk2E",
    authDomain: "partitions-6b6df.firebaseapp.com",
    databaseURL: "https://partitions-6b6df.firebaseio.com",
    projectId: "partitions-6b6df",
    storageBucket: "partitions-6b6df.appspot.com",
    messagingSenderId: "162369666758"
};
firebase.initializeApp(config);

firebase.firestore().settings(settings);

export default firebase;
